export default __webpack_public_path__ + "static/media/reddit.6bca7f55.png";